import React, { useMemo } from "react";
import "./banner-item.scss";
import { useDispatch } from "react-redux";
import {
  setBannerPosition,
  setModalBalance,
  setModalLogin,
  setTypeLogin
} from "../../../../store/siteSlice";
import useExternalLink from "../../../../hooks/common/useExternalLink";
import { useAppSelector } from "../../../../store/index.ts";
import { Link } from "react-router-dom";
import useGetLink from "../../../../hooks/other/useGetLink.js";
import { checkBonusGame, parseHashString } from "../../../../utils/utils.js";
import { setCurrency } from "../../../../store/userSlice.js";
import { ENUM_LCS_NAME, ENUM_LOGIN } from "../../../../store/enums.js";
import { useReadLocalStorage } from "usehooks-ts";
import { useTranslation } from "react-i18next";

const videoTypes = [".webm", ".avi", ".mp4", ".ogg"];

export default function BannerItem({
  id,
  gameId,
  fileUrl,
  mobileFileUrl,
  externalUrl,
  relativeUrl,
  position,
  gameInfo,
  makeBotLink
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const alreadyAccount = useReadLocalStorage(ENUM_LCS_NAME.alreadyAccount);

  const userId = useAppSelector((state) => state.user.userId);
  const isExtraSmall = useAppSelector((state) => state.deviceSize.isExtraSmall);
  const botName = useAppSelector((state) => state.common.botName);
  const isTgBot = useAppSelector((state) => state.common.isTgBot);
  const typeLogin = alreadyAccount ? ENUM_LOGIN.login : ENUM_LOGIN.register;

  const { playTg } = useExternalLink();

  const currentUrl = isExtraSmall ? mobileFileUrl || fileUrl : fileUrl;
  const accessibleText = `${t("Banner link")} ${id}`;

  const isVideo = videoTypes.some((el) => currentUrl?.includes(el));

  const linkHref = useMemo(() => {
    const getUrl = () => {
      if (!gameId) return;
      if (!gameInfo) return;

      const isBonus = checkBonusGame(gameInfo);
      if (isBonus) return "/bonus_game/" + gameId;
      return "/game/" + gameId;
    };

    console.log("makeBotLink", makeBotLink, !isTgBot && botName, playTg);

    if (!isTgBot && botName && makeBotLink) return { link: playTg, type: "href" };

    const url = getUrl();
    if (url) return { link: url, type: "to" };

    if (relativeUrl) return { link: relativeUrl, type: "to" };
    if (externalUrl) return { link: externalUrl, type: "href" };
    return { link: "", type: "to" };
  }, [isTgBot, botName, playTg, makeBotLink, gameId, relativeUrl, externalUrl]);

  const link = useGetLink(linkHref.link);

  const parseDeposit = () => {
    const hashes = parseHashString(relativeUrl);
    if (hashes.deposit) {
      if (!userId) {
        dispatch(setTypeLogin(typeLogin));
        dispatch(setModalLogin(true));
        // потом нужно будет доделать подставление валюты и суммы
        return;
      }
      const params = hashes.deposit;

      if (params) {
        const currency = params["currency"];
        const amount = params["amount"] || true;

        if (currency) dispatch(setCurrency(currency));
        dispatch(setModalBalance(amount));
      }
    }
  };

  const onBannerClick = () => {
    dispatch(setBannerPosition(position));
    parseDeposit();
  };

  const cursorClass = link ? "pointer" : "default";

  const BannerContent = () => (
    <div className={`banner-item ${cursorClass}`} id={id} onClick={onBannerClick}>
      <div className="banner-item__content">
        {isVideo ? (
          <video
            className="banner-item__video"
            src={currentUrl}
            autoPlay
            loop
            playsInline
            muted
            draggable={false}
            fetchPriority="high"
          />
        ) : (
          <img
            className="banner-item__img"
            src={currentUrl}
            fetchPriority="high"
            alt={t("img banner")}
          />
        )}
        <span className="visually-hidden">{accessibleText}</span>
      </div>
    </div>
  );

  return linkHref.type == "to" ? (
    link ? (
      <Link to={link} draggable="false" aria-label={accessibleText}>
        <BannerContent />
      </Link>
    ) : (
      <div>
        <BannerContent />
      </div>
    )
  ) : (
    <a
      href={linkHref.link}
      target="_blank"
      rel="noreferrer"
      draggable="false"
      aria-label={accessibleText}>
      <BannerContent />
    </a>
  );
}
